import {
    CancelationInterface,
    CancelationResponseInterface,
} from '@/core/domain/cancelation/models/cancelation.model';
import { CancelationRepository } from '@/core/domain/cancelation/repositories/cancelation.repository';
import { environment } from '@/env/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CancelationImplRepository extends CancelationRepository {
    constructor(private readonly httpClient: HttpClient) {
        super();
    }

    override cancelReservation(
        params: CancelationInterface,
    ): Observable<CancelationResponseInterface> {
        const httpParams = new HttpParams()
            .set('lastName', params.lastName)
            .set('reservationCode', params.reservationCode);

        return this.httpClient.delete<CancelationResponseInterface>(
            [
                environment.alamoApi.BASE_HOST,
                environment.alamoApi.ENDPOINTS.details,
            ].join('/'),
            { params: httpParams },
        );
    }
}
